<template>
  <MyHeader />

<!-- Hero Section -->
<div class="relative md:h-[80vh] min-h-[90vh] bg-gradient-to-b from-[#FFF2E0] via-[#FFF2E0] to-[#FFECE2] flex flex-col md:flex-row items-center justify-between px-8 animate__animated animate__fadeIn">

  <router-link to="/genesisgiveaway" class="md:hidden block genesis-banner absolute top-0 left-0 w-full bg-gradient-to-r from-[#FF6000] to-[#FF8C00] bg-opacity-90 text-white text-center py-2 z-50 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300">
    <div class="overflow-hidden whitespace-nowrap">
      <span class="inline-block animate-fluentMarquee text-lg font-semibold drop-shadow-md">
        CLICK HERE TO WIN 1 of 500 WALLETS 
      </span>
    </div>
  </router-link>


  <div class="hidden md:block absolute md:top-[6%] lg:top-[8%] left-[8%] md:left-[4%] lg:left-[8%] z-10 animate__animated animate__fadeInDown animate__delay-1s">
    <img src="../assets/BTClogo1.png" alt="BTC Logo" class="w-8 md:w-16 h-auto" />
  </div>

  <div class="w-full md:w-1/2 relative flex flex-col justify-start items-center md:ml-16 mb-6 md:-mt-16">
    <div class="w-full flex justify-center mt-6 relative z-20 animate__animated animate__fadeInDown animate__delay-1s">
        <a href="https://github.com/cardware-wallet" target="_blank" class="group flex mt-8 md:mt-2 items-center space-x-2 md:px-6 px-2 py-4 rounded-full transition-all duration-300 hover:scale-105">
          <!-- Left arrow SVG -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-8 h-8 text-[#FF6000] transition-transform duration-300 group-hover:scale-110">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span class="md:font-archivomedium font-archivoregular text-[#141523] md:text-xl text-lg text-center transition-colors duration-300 group-hover:text-[#FF6000]">
            Open Source Code
          </span>
          <!-- SVG representing a page of code -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6 text-[#FF6000] transition-transform duration-300">
            <rect x="2" y="2" width="20" height="20" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
            <line x1="6" y1="8" x2="18" y2="8" stroke="currentColor" stroke-width="2"/>
            <line x1="6" y1="12" x2="16" y2="12" stroke="currentColor" stroke-width="2"/>
            <line x1="6" y1="16" x2="14" y2="16" stroke="currentColor" stroke-width="2"/>
          </svg>
          <!-- Right arrow SVG -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-8 h-8 text-[#FF6000] transition-transform duration-300 group-hover:scale-110">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </a>
    </div>
    <div class="relative z-10 text-center mb-10">
      <h1 class="font-archivomedium text-[#141523] text-5xl md:text-6xl lg:text-7xl leading-tight animate__animated animate__fadeInDown">
        Cardware Wallet
      </h1>
      <p class="font-archivolight text-[#474747] text-md md:text-lg mt-4 md:my-6 lg:px-16 md:px-8 px-4 animate__animated animate__fadeInUp">
        Offline, air-gapped, and open-sourced hardware wallet solutions for your digital assets.
      </p>
      <div class="relative w-full flex flex-col sm:flex-row items-center justify-center z-20 mt-4 md:mt-8 space-y-4 sm:space-y-0 sm:space-x-4">
        <router-link to="/shop" class="px-6 py-2 bg-[#FF6000] shadow-2xl text-white hover:text-[#141523] font-archivomedium rounded-3xl border border-[#FF6000] hover:bg-[#FFF2E0] transition transform duration-300 hover:scale-105">
          Buy Cardware
        </router-link>
        <button @click="openWallet" class="px-6 py-2 bg-[#FF6000] shadow-2xl text-white hover:text-[#141523] font-archivomedium rounded-3xl border border-[#FF6000] hover:bg-[#FFF2E0] transition transform duration-300 hover:scale-105">
          Enter App
        </button>
      </div>
    
      <hr class="h-[1px] border-0 md:w-[80%] w-[90%] mx-auto mt-12 bg-gradient-to-r from-[#E48D7A]/10 via-[#E48D7A] to-[#E48D7A]/10 animate__animated animate__fadeInUp animate__delay-1s">
      
      <div class="mt-10 w-[95%] md:w-full lg:w-[90%] mx-auto space-y-4">
        <h2 class="text-2xl md:text-3xl font-archivomedium text-[#141523] text-center mb-6 animate__animated animate__fadeInUp animate__delay-1s">
          How it works
        </h2>
        <div class="flex flex-col md:flex-row gap-6">
            <div class="w-full md:w-1/2" @click="openModal('https://www.youtube.com/embed/ZpyfffAOCTU')">
              <div class="aspect-video cursor-pointer">
                <iframe src="https://www.youtube.com/embed/ZpyfffAOCTU" title="How it works video 1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="w-full h-full rounded-lg animate__animated animate__fadeInUp animate__delay-1s pointer-events-none"></iframe>
              </div>
            </div>

            <div class="w-full md:w-1/2" @click="openModal('https://www.youtube.com/embed/OH5eTBerBBc')">
              <div class="aspect-video cursor-pointer">
                <iframe src="https://www.youtube.com/embed/OH5eTBerBBc" title="How it works video 2" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="w-full h-full rounded-lg animate__animated animate__fadeInUp animate__delay-1s pointer-events-none"></iframe>
              </div>
            </div>
         </div>
      </div>
    </div>
  </div>

  <!-- Right Side Image -->
  <div class="w-full md:w-1/2 flex justify-center items-center">
    <img src="../assets/HPbackground3.png" alt="background" class="absolute inset-0 w-full h-full object-cover opacity-30 z-0 animate-fadeIn">
    <div class="rounded-lg shadow-lg hover:shadow-2xl mb-12 overflow-hidden w-10/12 h-auto md:w-2/3 md:h-auto lg:w-1/2 lg:h-1/2 animate__animated animate__fadeInUp animate__delay-1s" @mouseenter="pauseAutoHero" @mouseleave="resumeAutoHero">
      <transition name="fade">
        <img :src="heroImages[currentHeroIndex]" alt="Device Image" class="w-full h-full object-cover shadow-lg"/>
      </transition>
      <button @click="prevHeroImage" class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-gray-700 bg-opacity-50 text-white p-2 rounded-lg">
        &lt;
      </button>
      <button @click="nextHeroImage" class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-gray-700 bg-opacity-50 text-white p-2 rounded-lg">
        &gt;
      </button>  
    </div>
  </div> 
</div>


    <transition name="fade">
      <div v-if="modalVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75" @click.self="closeModal">
        <div class="relative w-11/12 md:w-3/4 lg:w-1/2">
          <button class="absolute top-2 right-2 text-white font-archivolight text-3xl" @click="closeModal">&times;</button>
          <div class="aspect-video">
            <iframe :src="activeVideo" title="Expanded video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="w-full h-full rounded-lg"></iframe>
          </div>
        </div>
      </div>
    </transition>


    <!-- Table Section -->
    <div class="w-full h-full relative bg-[#FFF9F7] pt-20 pb-12">
        <h1 class="text-4xl md:text-5xl text-[#141523] text-center font-archivonormal mb-4 px-4">Hardware Wallet Comparison</h1>
        <p class="text-md text-center text-[#474747] font-archivolight mb-12 px-8">A comparison of current hardware wallets & their features</p>
        <div class="overflow-auto md:mx-16 ml-2">
            <div class="w-[2200px] overflow-x custom-scrollbar bg-[#FFF9F7]">
                <table class="w-full border-separate border-spacing-x-4 border-collapse bg-[#FFF9F7] text-[#141523]">
                    <thead>
                        <tr>
                            <th class="sticky left-0 bg-[#FFF9F7] p-1 z-10"></th>
                            <!-- Cardware Wallet column remains sticky -->
                            <th class="md:sticky left-40 bg-[#FFF9F7] p-1 rounded-t-lg z-10">
                                <img src="../assets/CW_HomePageDevice1.png" alt="Device 1" class="w-32 h-auto mx-auto brightness-110">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/ColdCardMK4.png" alt="Coldcard MK4" class="w-32 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/ColdcardQ.png" alt="Coldcard Q" class="w-24 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/EllipalTitan2.png" alt="Ellipal Titan 2.0" class="w-32 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/Keystone3Pro.png" alt="Keystone 3 Pro" class="w-32 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/LedgerNanoS.png" alt="Ledger Nano S" class="w-32 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/LedgerNanoX.png" alt="Ledger Nano X" class="w-32 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/LedgerStax.png" alt="Ledger Stax" class="w-24 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/SafePalS1Pro.png" alt="Safepal S1 Pro" class="w-28 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/Seedsigner.png" alt="Seedsigner" class="w-32 h-50 mx-auto">
                            </th>
                            <th class="bg-[#FFF9F7] p-1">
                                <img src="../assets/TrezorModelT.png" alt="Trezor Model T" class="w-32 h-50 mx-auto">
                            </th>             
                        </tr>
                        <tr class="text-lg">
                            <th class="sticky left-0 bg-[#FFF9F7] min-w-40 p-1 font-archivomedium z-10">Device</th>
                            <!-- Column Headers reordered alphabetically -->
                            <th class="md:sticky left-40 bg-[#FFF9F7] min-w-48 md:min-w-60 p-1 z-10">Cardware Wallet</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Coldcard MK4</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Coldcard Q</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Ellipal Titan 2.0</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Keystone 3 Pro</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Ledger Nano S</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Ledger Nano X</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Ledger Stax</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Safepal S1 Pro</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">SeedSigner</th>
                            <th class="bg-[#FFF9F7] min-w-40 p-1 font-archivomedium">Trezor Model T</th>
                        </tr>
                    </thead>
                    <tbody id="tableBody" class="font-archivolight text-sm">
                        <tr>
                          <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Price</td>
                          <td class="md:sticky left-40 bg-[#CFE9CF] text-slate-900 font-archivoregular shadow-md shadow-slate-400 rounded-t-md p-1 z-10">
                            $77.00
                            <p class="text-xs text-gray-600">{{ (77.00 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $157.94
                            <p class="text-xs text-gray-600">{{ (157.94 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $219.99
                            <p class="text-xs text-gray-600">{{ (219.99 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $169.00
                            <p class="text-xs text-gray-600">{{ (169.00 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $149.00
                            <p class="text-xs text-gray-600">{{ (149.00 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $79.00
                            <p class="text-xs text-gray-600">{{ (79 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $149.00
                            <p class="text-xs text-gray-600">{{ (149.00 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $399.00
                            <p class="text-xs text-gray-600">{{ (399.00 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $89.99
                            <p class="text-xs text-gray-600">{{ (89.99 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $80.00
                            <p class="text-xs text-gray-600">{{ (80.00 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                          <td class="bg-[#FDAFAB] text-slate-900 font-archivoregular p-1 rounded-t-md">
                            $149.00
                            <p class="text-xs text-gray-600">{{ (149.00 * usdToZarRate).toFixed(2) }} ZAR</p>
                          </td>
                        </tr>

                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">100% Air-Gapped</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] text-slate-900  border-t border-[#B2B2B2] shadow-md shadow-slate-400 p-1 z-10">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Only for transactions</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 min-w-40 z-10">Transfer data via USB<span class="absolute ml-2">
                                    <img src="@/assets/Info3.png" alt="Info" class="mt-1 cursor-pointer animate__animated animate__pulse animate__infinite" @mouseenter="showInfo1 = true" @mouseleave="showInfo1 = false" @click="showInfo1 = !showInfo">
                                    <transition name="fade">
                                    <div v-if="showInfo1" class="shadow-md border border-gray-200 absolute w-48 bottom-full left-1/2 transform -translate-x-1/2 bg-white text-gray-700 text-xs p-2 rounded-md z-10">
                                     All Cardware Wallets provide complete transparency by clearly displaying on the circuit board that no data connections are active. It is easy for anyone to verify that only the power and ground are connected to the USB-C port, while all data lines remain disconnected.
                                    </div>
                                </transition>
                              </span ></td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">100% Offline</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Connection Method</td>
                            <td class="md:sticky left-40 bg-[#FFF9F7] border-t border-[#B2B2B2] shadow-md shadow-slate-400 text-slate-900 p-1 z-10">QR Code Scanning</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">USB-C</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">USB-C</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">QR Code Scanning</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">QR Code Scanning</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">USB-C</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">USB-C/Bluetooth</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">USB-C</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">QR Code Scanning</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">QR Code Scanning</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">USB-C</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Secure Chip Certification</td>
                            <td class="md:sticky left-40 bg-[#FFF9F7] border-t border-[#B2B2B2] shadow-md shadow-slate-400 text-slate-900 p-1 z-10">CC EAL6+</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">No Certification (2 Chips)</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">No Certification (2 Chips)</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">CC EAL5+</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">PCI</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">CC EAL5+</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">CC EAL5+</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">CC EAL6+</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">CC EAL5+</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">No Secure Element</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">No Secure Element</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Supported Devices</td>
                            <td class="md:sticky left-40 bg-[#FFF9F7] border-t border-[#B2B2B2] shadow-md shadow-slate-400 text-slate-900 p-1 z-10">ANY device with a Web Browser</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">N/A</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">N/A</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">
                                <img src="../assets/And_IOS1.png" alt="Device 3">
                            </td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">
                                <img src="../assets/And_IOS1.png" alt="Device 4">
                            </td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">
                                <img src="../assets/SupDev.png" alt="Device 6">
                            </td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">
                                <img src="../assets/Sup_Dev1.png" alt="Device 5">
                            </td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">
                                <img src="../assets/Sup_Dev1.png" alt="Device 5">
                            </td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">
                                <img src="../assets/Sup_Dev2.png" alt="Device 5">
                            </td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">N/A</td>
                            <td class="bg-[#FFF9F7] border-t border-[#B2B2B2] p-1">
                                <img src="../assets/Sup_Dev3.png" alt="Device 5">
                            </td>
                        </tr>
                        <!--<tr >
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Lightning Support</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (Open Node)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (Confirmo.net)</td>
                        </tr>-->
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Source Available</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Transparent Product</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Semi-Transparent</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Semi-Transparent</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">BTC Only Support</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">Yes (BTC Only product)</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Altcoin Support</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">Yes (BTC & EVM product)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Multisig Support (PSBTs)</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1">Yes</td>
                        </tr>
                       <!-- <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Firmware Upgradable<span class="absolute ml-2">
                                    <img src="@/assets/Info3.png" alt="Info" class="mt-1 cursor-pointer animate__animated animate__pulse animate__infinite" @mouseenter="showInfo = true" @mouseleave="showInfo = false" @click="showInfo = !showInfo">
                                    <transition name="fade">
                                    <div v-if="showInfo" class="shadow-md border border-gray-200 absolute w-48 bottom-full left-1/2 transform -translate-x-1/2 bg-white text-gray-700 text-xs p-2 rounded-md z-10">
                                     By preventing firmware upgrades & code rewrites, hardware wallets (as a signing device mechanism) maintain a static and immutable codebase, reducing the attack surface and mitigating risks associated with firmware tampering or unauthorized code injections.
                                    </div>
                                </transition>
                              </span ></td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (MicroSD)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (MicroSD)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (MicroSD)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (MicroSD or USB)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (USB)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (USB)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (Bluetooth)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (USB)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (MicroSD)</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Yes (USB)</td>
                        </tr>-->
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Steel Seed Phrase</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Separate Product</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Separate Product</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Separate Product</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Separate Product</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Separate Product</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">Separate Product</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1">No</td>
                        </tr>
                        <tr>
                            <td class="sticky left-0 bg-[#FFF9F7] border-t border-[#B2B2B2] font-archivoregular p-1 z-10">Microcontroller Read/Write Protection</td>
                            <td class="md:sticky left-40 bg-[#CFE9CF] border-t border-[#B2B2B2] text-slate-900 shadow-md shadow-slate-400 p-1 z-10 rounded-b-md">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">No</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">Yes</td>
                            <td class="bg-[#CFE9CF] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">Yes</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">No</td>
                            <td class="bg-[#FDAFAB] text-[#474747] border-t border-[#B2B2B2] p-1 rounded-b-md">No</td>
                        </tr>
                    </tbody>
                </table>
        </div>
    </div>
     <p class="text-xs font-archivolight italic text-center pt-12 pl-10 pr-10 md:pl-20 md:pr-20 ">Disclaimer: The data above is sourced from publicly available information and may be subject to change. If you represent a hardware wallet competitor listed and find any inaccuracies, please contact us for corrections.</p>
     

    <!-- Features -->
    <div class="min-h-[80vh] flex flex-col items-center bg-gradient-to-b from-[#FFECE2] via-[#FFF2E0] to-[#FFF2E0] mt-12 p-4 md:p-8 relative overflow-hidden">
        <!-- Background Image -->
        <div class="absolute inset-0 bg-cover bg-center opacity-60 z-0">
            <img src="../assets/FeaturesBGFinal1.png" alt="Features Background" class="flex w-full h-full opacity-60 object-cover">
        </div>

        <!-- Main Header -->
        <header class="text-center mb-4 relative z-10">
            <h1 class="text-4xl md:text-5xl text-[#141523] text-center font-archivonormal mt-8">Features</h1>
        </header>
        
        <!-- Images -->
        <div class="mb-10 mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mobile-landscape:grid-cols-2 lg:px-4 md:px-20 px-12 md:mt-4 lg:mt-0 gap-3 md:gap-6 lg:gap-x-8 relative z-10 w-full max-w-screen-xl items-stretch">
            <div class="feature-item bg-white rounded-xl shadow-md shadow-slate-400 transform transition duration-500 hover:scale-105 hover:shadow-xl lg:mt-10 relative group" @click="toggleFeature(0)">
                <img src="../assets/FeatAG.png" alt="100% Air-Gapped" class="w-full h-full object-cover rounded-lg">
                <img src="../assets/Info2.png" alt="Info" class="absolute bottom-2 right-2 w-4 h-4 opacity-80 group-hover:opacity-100">
                <div v-if="activeFeature === 0" class="absolute inset-0 bg-[#F8F6F5] flex items-center justify-center text-center text-xs md:text-[0.77rem] lg:text-[0.80rem] text-[#141523] font-archivoregular rounded-lg py-2 px-4 transition-all duration-500 overflow-y-auto"><img src="../assets/Frame 24 (3).png" alt="Airgapped Feature" class="absolute top-2 left-1 md:left-2 md:w-6 md:h-6 w-4 h-4">
                    Cardware ensures security by operating completely offline in an air-gapped environment, with no WiFi, Bluetooth, or NFC. All functions are handled via QR codes & powered by a USBC (with no data transfer), keeping private keys safely stored (and encrypted) in tamperproof EAL6+ chips.
                </div>
            </div>
            <div class="feature-item bg-white rounded-xl shadow-md shadow-slate-400 transform transition duration-500 hover:scale-105 hover:shadow-2xl lg:mt-10 relative group" @click="toggleFeature(1)">
                <img src="../assets/FeatEAL6.png" alt="Battery Powered" class="w-full h-full object-cover rounded-lg">
                <img src="../assets/Info2.png" alt="Info" class="absolute bottom-2 right-2 w-4 h-4 opacity-80 group-hover:opacity-100">
                <div v-if="activeFeature === 1" class="absolute inset-0 bg-[#F8F6F5] flex items-center justify-center text-center text-xs md:text-[0.77rem] lg:text-[0.80rem] text-[#141523] font-archivoregular rounded-lg py-2 px-4 transition-all duration-500 overflow-y-auto"><img src="../assets/Frame 24 (3).png" alt="EAL6+ Feature" class="absolute top-2 left-1 md:left-2 md:w-6 md:h-6 w-4 h-4">
                    Cardware Wallets feature an EAL6+ certified secure element, providing protection against attack vectors. This security measure ensures your private keys are secure in a tamper-resistant environment.
                </div>
            </div>
            <div class="feature-item bg-white rounded-xl shadow-md shadow-slate-400 transform transition duration-500 hover:scale-105 hover:shadow-2xl lg:mt-10 relative group" @click="toggleFeature(2)">
                <img src="../assets/FeatPK.png" alt="Web Accessible" class="w-full h-full object-cover rounded-lg">
                <img src="../assets/Info2.png" alt="Info" class="absolute bottom-2 right-2 w-4 h-4 opacity-80 group-hover:opacity-100">
                <div v-if="activeFeature === 2" class="absolute inset-0 bg-[#F8F6F5] flex flex-col items-center justify-center text-center text-xs md:text-[0.77rem] lg:text-[0.80rem] text-[#141523] font-archivoregular rounded-lg py-2 px-4 transition-all duration-500 overflow-y-auto"><img src="../assets/Frame 24 (3).png" alt="Private Key Feature" class="absolute top-2 left-1 md:left-2 md:w-6 md:h-6 w-4 h-4">
                    Cardware offers 3 high entropy methods to create your private key; Hashed Video Stream, D20 dice rolls and D6 dice rolls. These high entropy methods are user generated, and directly from the environment around you taking into account real world randomness.<a href="https://docs.cardwarewallet.com/cardware-wallet-documentation/features/security-features#high-entropy-key-generation" target="_blank" class="text-[#FF6000]"> Learn More.</a>
                </div>
            </div>
            <div class="feature-item bg-white rounded-xl shadow-md shadow-slate-400 transform transition duration-500 hover:scale-105 hover:shadow-2xl lg:mt-10 relative group" @click="toggleFeature(3)">
                <img src="../assets/DataTransferFeat.png" alt="High Entropy Private Key Generation" class="w-full h-full object-cover rounded-lg">
                <img src="../assets/Info2.png" alt="Info" class="absolute bottom-2 right-2 w-4 h-4 opacity-80 group-hover:opacity-100">
                <div v-if="activeFeature === 3" class="absolute inset-0 bg-[#F8F6F5] flex items-center justify-center text-center text-xs md:text-[0.77rem] lg:text-[0.80rem] text-[#141523] font-archivoregular rounded-lg py-2 px-4 transition-all duration-500 overflow-y-auto"><img src="../assets/Frame 24 (3).png" alt="Data Transfer Feature" class="absolute top-2 left-1 md:left-2 md:w-6 md:h-6 w-4 h-4">
                     All Cardware Wallets provide complete transparency by clearly displaying on the circuit board that no data connections are active. It is easy for anyone to verify that only the power and ground are connected to the USB-C port, while all data lines remain disconnected.
                </div>
            </div>
          
            <div class="feature-item bg-white rounded-xl shadow-md shadow-slate-400 transform transition duration-500 hover:scale-105 hover:shadow-xl lg:mt-4 relative group" @click="toggleFeature(4)">
                <img src="../assets/FeatWebComp.png" alt="100% Air-Gapped" class="w-full h-full object-cover rounded-lg">
                <img src="../assets/Info2.png" alt="Info" class="absolute bottom-2 right-2 w-4 h-4 opacity-80 group-hover:opacity-100">
                <div v-if="activeFeature === 4" class="absolute inset-0 bg-[#F8F6F5] flex items-center justify-center text-center text-xs md:text-[0.77rem] lg:text-[0.80rem] text-[#141523] font-archivoregular rounded-lg py-2 px-4 transition-all duration-500 overflow-y-auto"><img src="../assets/Frame 24 (3).png" alt="Web Compatability Feature" class="absolute top-2 left-1 md:left-2 md:w-6 md:h-6 w-4 h-4">
                    Cardware Wallet integrates with web platforms using NPM packages, allowing developers to add secure, offline hardware wallet functionality to their platforms directly through Web.
                </div>
            </div>
            <div class="feature-item bg-white rounded-xl shadow-md shadow-slate-400 transform transition duration-500 hover:scale-105 hover:shadow-2xl lg:mt-4 relative group" @click="toggleFeature(5)">
                <img src="../assets/FeatMultisig.png" alt="Battery Powered" class="w-full h-full object-cover rounded-lg">
                <img src="../assets/Info2.png" alt="Info" class="absolute bottom-2 right-2 w-4 h-4 opacity-80 group-hover:opacity-100">
                <div v-if="activeFeature === 5" class="absolute inset-0 bg-[#F8F6F5] flex items-center justify-center text-center text-xs md:text-[0.77rem] lg:text-[0.80rem] text-[#141523] font-archivoregular rounded-lg py-2 px-4 transition-all duration-500 overflow-y-auto"><img src="../assets/Frame 24 (3).png" alt="Multisig Feature" class="absolute top-2 left-1 md:left-2 md:w-6 md:h-6 w-4 h-4">
                    Cardware Wallet enables multisig support, requiring multiple signatures for transactions. This adds a layer of security, ideal for collaborative control for individuals or corporations - all within secure, offline environments.
                </div>
            </div>
            <div class="feature-item bg-white rounded-xl shadow-md shadow-slate-400 transform transition duration-500 hover:scale-105 hover:shadow-2xl lg:mt-4 relative group" @click="toggleFeature(6)">
                <img src="../assets/FeaturesMicrocontroller1.png" alt="Web Accessible" class="w-full h-full object-cover rounded-lg">
                <img src="../assets/Info2.png" alt="Info" class="absolute bottom-2 right-2 w-4 h-4 opacity-80 group-hover:opacity-100">
                <div v-if="activeFeature === 6" class="absolute inset-0 bg-[#F8F6F5] flex items-center justify-center text-center text-xs md:text-[0.77rem] lg:text-[0.80rem] text-[#141523] font-archivoregular rounded-lg py-2 px-4 transition-all duration-500 overflow-y-auto"><img src="../assets/Frame 24 (3).png" alt="Microcontroller Feature" class="absolute top-2 left-1 md:left-2 md:w-6 md:h-6 w-4 h-4">
                    By preventing firmware upgrades and using microcontrollers with non-rewritable flash memory, hardware wallets like Cardware Wallet maintain a static, immutable codebase. This reduces the attack surface and mitigates risks of unauthorized code modifications such as Juice Jacking and Dark Skippy.
                </div>
            </div>
            <div class="feature-item bg-white rounded-xl shadow-md shadow-slate-400 transform transition duration-500 hover:scale-105 hover:shadow-2xl lg:mt-4 relative group" @click="toggleFeature(7)">
                <img src="../assets/MultipleDeviceOptions.png" alt="High Entropy Private Key Generation" class="w-full h-full object-cover rounded-lg">
                <img src="../assets/Info2.png" alt="Info" class="absolute bottom-2 right-2 w-4 h-4 opacity-80 group-hover:opacity-100">
                <div v-if="activeFeature === 7" class="absolute inset-0 bg-[#F8F6F5] flex items-center justify-center text-center text-xs md:text-[0.77rem] lg:text-[0.80rem] text-[#141523] font-archivoregular rounded-lg py-2 px-4 transition-all duration-500 overflow-y-auto"><img src="../assets/Frame 24 (3).png" alt="Asset Support Feature" class="absolute top-2 left-1 md:left-2 md:w-6 md:h-6 w-4 h-4">
                    Cardware Wallet provides BTC Only Devices or BTC & EVM devices allowing users to manage their BTC or multiple assets within a single device efficiently.
                </div>
            </div>
        </div>
    </div>


    <!-- Products, Apps & Services Section -->
    <div class="min-h-[90vh] flex flex-col items-center bg-[#FFF9F7] pt-8 pb-12 md:pb-16 lg:pb-20 mb-6">
      <header class="text-center mb-8 md:mb-12 lg:mb-16">
        <h1 class="text-4xl md:text-5xl text-[#141523] font-archivonormal mt-12 px-8">
          Products, Apps & Services
        </h1>
        <p class="text-md text-[#474747] font-archivolight pt-8 px-4">
          Discover our Cardware Products, Services, and easy-to-use Web App.
        </p>
      </header>
      <div class="w-full max-w-6xl px-4">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 px-12 md:px-2">
          
          <!-- Column 1: Cardware Web App -->
          <div class="relative bg-gradient-to-b from-[#F4F4F4] via-[#E6E6E6] to-[#DCDCDC] shadow-inner rounded-xl overflow-hidden flex flex-col hover:shadow-xl hover:scale-105 transition duration-300 animate__animated animate__fadeInUp">
            <div class="relative overflow-visible">
              <img src="../assets/WebBrowserSupport_1.png" alt="Cardware Web App" class="mt-8 w-full h-auto pulsate" />
            </div>
            <div class="p-6 mt-auto">
              <h2 class="text-2xl font-archivoregular text-[#141523] mb-2 text-center">Cardware Web App</h2>
              <p class="text-[#474747] opacity-80 text-sm text-center">
                Utilise our watch-only Web App to manage and transact with your digital assets.
              </p>
            </div>
          </div>


          <!-- Column 2: Cardware Wallet Device -->
          <div class="relative bg-gradient-to-b from-[#F4F4F4] via-[#E6E6E6] to-[#DCDCDC] shadow-inner rounded-xl overflow-hidden flex flex-col hover:shadow-xl hover:scale-105 transition duration-300 animate__animated animate__fadeInDown">
            <div class="relative overflow-visible">
              <img src="../assets/CW_HomePageDevice1.png" alt="Cardware Wallet Device" class="w-1/2 h-auto pulsate mx-auto mt-10" />
            </div>
            <div class="p-6 mt-auto">
              <h2 class="text-2xl font-archivoregular text-[#141523] mb-2 text-center">Cardware Wallet Device</h2>
              <p class="text-[#474747] opacity-80 text-sm text-center">
                Secure your assets the right way. The Air-Gapped Way.
              </p>
            </div>
          </div>

          <!-- Column 3: Cardware Services -->
          <div class="relative bg-gradient-to-b from-[#F4F4F4] via-[#E6E6E6] to-[#DCDCDC] shadow-inner rounded-xl overflow-hidden flex flex-col hover:shadow-xl hover:scale-105 transition duration-300 animate__animated animate__fadeInUp">
            <div class="relative overflow-visible">
              <img src="../assets/CWWservices.png" alt="Cardware Services" class="w-2/5 h-auto pulsate mx-auto mt-12" />
            </div>
            <div class="p-6 mt-auto">
              <h2 class="text-2xl font-archivoregular text-[#141523] text-center mb-2">Cardware Enterprise</h2>
              <p class="text-[#474747] opacity-80 text-sm text-center">
                Set up Branded Hardware Wallets that directly integrate with Web.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- Enterprise -->
    <div class="md:h-[90vh] h-[90vh] mobile-landscape:h-screen flex flex-col items-center bg-gradient-to-b from-[#FFF2E0] via-[#FFF2E0] to-[#FFECE2] p-8 relative overflow-hidden">
      <header class="text-center mb-6 relative z-10">
        <h1 class="text-4xl md:text-5xl text-[#141523] text-center font-archivonormal md:mt-4 md:mt-10 md:pb-6">Cardware Enterprise</h1>
        <p class="block text-base text-md text-[#474747] text-center font-archivolight mt-4 md:pb-6 mb-6 max-w-3xl mx-auto">Connect your custodial world to a self custodial Cardware Wallet. Setup branded hardware wallets for communities, companies & exchanges - all through Web</p> 
        <router-link to='/enterprise' class="bg-[#FF6000] text-white font-archivoregular text-md py-3 px-8 rounded-3xl shadow-xl border border-[#FF6000] hover:scale-105 hover:text-[#141523] hover:bg-transparent transform transition duration-500 hover:scale-105 md:mt-8 m">Learn More</router-link>
      </header>
      <div class="absolute inset-0 bg-cover bg-center z-0 w-full h-full">
        <img src="../assets/EnterpriseBG13.png" alt="Enterprise Background" class="w-full h-full opacity-60 object-cover">
        <div class="absolute inset-0 bg-cover bg-center z-0 w-full h-full flex justify-center items-end pb-8 md:pb-12 lg:pb-16">
          <div class="carousel w-full h-1/2 flex justify-center items-center pt-6 md:pt-0">
        <button @click="prevImage" class="mr-2 text-white p-2 rounded-full hover:bg-opacity-75 focus:outline-none bg-gray-700 bg-opacity-50">
          &lt;
        </button>
        <transition name="fade">
            <img :src="currentImage" alt="Enterprise Images" class="w-auto h-full mb-4 object-contain transition-opacity duration-500 ease-in-out">
        </transition>
        <button @click="nextImage" class="ml-2 text-white p-2 rounded-full hover:bg-opacity-75 focus:outline-none bg-gray-700 bg-opacity-50"> 
            &gt;
        </button>
          </div>
        </div>
        <div class="absolute bottom-5 left-0 right-0 z-10 flex justify-center space-x-2">
          <span v-for="(img, index) in images" :key="index" @click="setImage(index)" :class="currentIndex === index ? 'bg-[#FF6000]' : 'bg-gray-400'"
            class="w-3 h-3 rounded-full cursor-pointer">
          </span>
        </div>
      </div>
    </div>



    <!-- FAQs -->
    <div class="min-h-[70vh] flex flex-col items-center bg-[#FFF9F7] pt-16">
      <div class="w-full lg:w-8/12 px-4 rounded-2xl pb-8">
        <div class="flex justify-center mb-8">
          <h1 class="font-archivonormal md:px-6 md:py-2 px-4 py-2 text-4xl md:text-5xl border-b border-[#FF6000] text-[#141523]">FAQs</h1>
        </div>
        <p class="text-md text-center font-archivolight text-[#474747] pb-8">Find your Frequently Asked Questions Below</p>
        <div v-for="faq in faqs" :key="faq.id" class="text-base mb-4 px-4">
          <div @click="toggleAnswer(faq.id)" class="cursor-pointer py-2 border-b border-gray-300">
            <h2 class="text-l font-archivoregular">{{ faq.question }}</h2>
          </div>
          <transition name="expand">
            <div v-if="faq.show" class="overflow-hidden">
               <p class="py-2 text-[#6C6C6C] text-sm font-archivolight" v-html="faq.answer"></p>
            </div>
          </transition>
        </div>
      </div>
    </div>
 </div>

 <!-- Footer -->
 <MyFooter />

</template>


<script setup>
import MyHeader from './MyHeader.vue';
import MyFooter from './MyFooter.vue';
import { ref, onMounted, onUnmounted} from 'vue';
import axios from 'axios';
import { useHead } from '@vueuse/head'; 


useHead({
  title: 'Cardware Wallet: Best Air-Gapped Crypto Hardware Wallets for BTC & ETH',
  meta: [
    {
      name: 'description',
      content: 'Discover Cardware Wallet’s secure Bitcoin and Ethereum hardware wallets featuring air-gapped, offline protection. Shop now for affordable crypto security!',
    },
    {
      name: 'keywords',
      content: 'Best hardware wallets for Bitcoin, Secure Ethereum hardware wallet, Air-gapped crypto wallets, Affordable crypto hardware wallets, Buy hardware wallet for BTC and ETH, Cold storage for cryptocurrencies, Secure offline crypto storage, Protect digital assets, Crypto security solutions, High-security hardware wallets',
    },
    // Open Graph Meta Tags
    {
      property: 'og:title',
      content: 'Cardware Wallet: Best Air-Gapped Crypto Hardware Wallets for BTC & ETH',
    },
    {
      property: 'og:description',
      content: 'Secure your digital assets with Cardware Wallet’s air-gapped, offline hardware wallets for Bitcoin and Ethereum. Perfect for individuals and institutions.',
    },
    {
      property: 'og:image',
      content: 'https://www.cardwarewallet.com/img/OGimage1.a2f2d85d.jpg', 
    },
    {
      property: 'og:url',
      content: 'https://cardwarewallet.com/', 
    },
    {
      property: 'og:type',
      content: 'website',
    },
    // Twitter Card Meta Tags
    {
      name: 'twitter:title',
      content: 'Cardware Wallet: Best Air-Gapped Crypto Hardware Wallets for BTC & ETH',
    },
    {
      name: 'twitter:description',
      content: 'Secure your digital assets with Cardware Wallet’s air-gapped, offline hardware wallets for Bitcoin and Ethereum. Perfect for individuals and institutions.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.cardwarewallet.com/img/TwitterCard.de9c6946.jpg', 
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],

  link: [
    {
      rel: 'canonical',
      href: 'https://cardwarewallet.com/',
    },
    {
      rel: 'icon',
      href: '/CWfavicon.png',
    },
    {
      rel: 'apple-touch-icon',
      href: '/CWfavicon.png',
    },
  ],
  
  script: [
  {
    type: 'application/ld+json',
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Cardware Wallet",
      "image": [
        "https://www.cardwarewallet.com/img/SPBTCDevice.3c761c6f.png"
      ],
      "description": "Secure your digital assets with Cardware Wallet’s air-gapped, offline hardware wallets for Bitcoin and Ethereum. Perfect for individuals and institutions.",
      "brand": {
        "@type": "Brand",
        "name": "Cardware"
      },
      "offers": {
        "@type": "Offer",
        "url": "https://cardwarewallet.com/shop",
        "priceCurrency": "USD",
        "price": "77.00",
        "priceValidUntil": "2024-12-31",
        "availability": "https://schema.org/PreOrder", 
        "itemCondition": "https://schema.org/NewCondition"
      }
    }),
  },
],
});

const openWallet = () => {
  window.open("https://wallet.cardwarewallet.com", '_blank');
};

const usdToZarRate = ref(null);

onMounted(() => {
  axios
    .get("https://api.exchangerate-api.com/v4/latest/USD")
    .then((response) => {
      usdToZarRate.value = response.data.rates.ZAR;
    })
    .catch((error) => {
      console.error("Error fetching ZAR exchange rate", error);
    });
});

const images = [
  require('../assets/EnterpriseImg1.png'),
  require('../assets/EnterpriseImage_2.png'),
  require('../assets/EnterpriseImg3.png'),
  require('../assets/EnterpriseImage_4.png'),
];

const currentIndex = ref(0);
const currentImage = ref(images[0]);

const nextImage = () => {
  currentIndex.value = (currentIndex.value + 1) % images.length;
  currentImage.value = images[currentIndex.value];
};

const prevImage = () => {
  currentIndex.value =
    (currentIndex.value - 1 + images.length) % images.length;
  currentImage.value = images[currentIndex.value];
};

const setImage = (index) => {
  currentIndex.value = index;
  currentImage.value = images[index];
};

const showInfo = ref(false);
const showInfo1 = ref(false);

const heroImages = [
  require('../assets/HomeHeroImg2.jpg'),
  require('../assets/HomeHeroImg15.jpg'),
  require('../assets/HomeHeroImg16.jpg'),
  require('../assets/HomeHeroImg17.jpg'),
  require('../assets/HomeHeroImg18.jpg'),
  require('../assets/HomeHeroImg7.jpg'),
  //require('../assets/HomeHeroImg3.jpg'),

  //require('../assets/HomeHeroImg14.jpg'),  
  //require('../assets/HomeHeroImg8.jpg'),
  //require('../assets/HomeHeroImg14.jpg'),
  //require('../assets/HomeHeroImg5.jpg'),
  //require('../assets/HomeHeroImg3.jpg'),
  //require('../assets/HomeHeroImg1.jpg'),
  //require('../assets/HomeHeroImg6.jpg'),
  //require('../assets/HomeHeroImg7.jpg'),
];

const preloadImages = () => {
  heroImages.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};

const currentHeroIndex = ref(0);
const currentHeroImage = ref(heroImages[0]);

const nextHeroImage = () => {
  currentHeroIndex.value = (currentHeroIndex.value + 1) % heroImages.length;
  currentHeroImage.value = heroImages[currentHeroIndex.value];
};

const prevHeroImage = () => {
  currentHeroIndex.value = (currentHeroIndex.value - 1 + heroImages.length) % heroImages.length;
  currentHeroImage.value = heroImages[currentHeroIndex.value];
};


let autoHeroInterval;

const startAutoHero = () => {
  autoHeroInterval = setInterval(() => {
    nextHeroImage();
  }, 1300);
};

const pauseAutoHero = () => {
  if (autoHeroInterval) {
    clearInterval(autoHeroInterval);
    autoHeroInterval = null;
  }
};

const resumeAutoHero = () => {
  if (!autoHeroInterval) {
    startAutoHero();
  }
};

onMounted(() => {
  preloadImages();
  const timer = setTimeout(() => {
    startAutoHero();
  }, 2500);

  onUnmounted(() => {
    clearTimeout(timer);
    if (autoHeroInterval) {
      clearInterval(autoHeroInterval);
    }
  });
});


const faqs = ref([
  {
    id: 1,
    question: 'What is Cardware Wallet?',
    answer: 'Cardware Wallet is an air-gapped, offline hardware wallet designed to provide secure, affordable, and offline signing for your digital asset holders. By operating entirely offline, the device remains isolated from online networks, significantly reducing the risk of unauthorized access or cyberattacks. This makes Cardware Wallet an ideal choice for individuals and institutions seeking to safeguard their cryptocurrencies in a highly secure environment.',
    show: false,
  },
  {
    id: 2,
    question: 'How do I set up my Cardware Wallet?',
    answer: 'Setting up your Cardware Wallet involves a few straightforward steps and can be done in less than 2 minutes. Simply plugin, generate your private key and set a pin. For more infomation on getting started, see our <a href="https://www.cardwarewallet.com/start" target="_blank" rel="noopener noreferrer" class="underline text-[#FF6000]">guides</a>',
    show: false, 
  },
  {
    id: 3,
    question: 'What are the unique features of Cardware Wallet?',
    answer: 'Cardware Wallet is distinguished by several key features that make it a robust option for securing digital assets. These include its air-gapped and offline design, ensuring that the wallet is never connected to the internet and thus minimizing exposure to cyber threats. Despite its offline nature, the device is web-accessible, allowing users to interact with it via a browser without compromising security, meaning it is accessible on any device with a browser. The wallet is equipped with a secure element chip (EAL6+ certified), providing an additional layer of protection against tampering. A notable feature is its high-entropy private key generation method, which uses the user’s physical surroundings or inputs to generate a truly random key. This method, combined with the device’s passphrase support and self-destruct feature, that activates upon any unauthorized attempts to rewrite code, makes Cardware Wallet a highly secure choice for both individual and institutional users.',
    show: false,
  },
  {
    id: 4,
    question: 'How secure is Cardware Wallet?',
    answer: 'Cardware Wallet offers a high level of security through its air-gapped design, ensuring that the device operates entirely offline, thus eliminating risks associated with online attacks. The device is equipped with a secure element chip (EAL6+ certified), providing hardware-level security against physical tampering. Furthermore, the wallet\'s private key generation process is highly secure, utilizing a method that captures random pixels from images taken of the user’s surroundings, ensuring that each key is unique and cannot be replicated.',
    show: false,
  },
  {
    id: 5,
    question: 'Can I use Cardware Wallet for my company?',
    answer: 'Yes, Cardware Wallet is designed to cater to both individual and institutional users. For companies, Cardware Wallet offers B2B solutions that enable the setup of branded hardware wallets for clients, and internal use. These hardware wallets can be fully integrated into a company’s existing web infrastructure, allowing seamless management of digital assets while maintaining a high level of security. This is particularly useful for organizations that require a secure, offline method of storing and managing cryptocurrencies or need to provide secure wallet solutions to their customers.',
    show: false,
  },
  {
    id: 6,
    question: 'How do I contact Cardware Wallet support?',
    answer: 'You can contact Cardware Wallet support through multiple channels. Users can submit support tickets via the Cardware Wallet Discord server, where our support team is available to assist with any issues or questions. Additionally, you can reach out by emailing contact@cardwarewallet.com. Please provide detailed information about your issue to ensure a prompt and accurate response.',
    show: false,
  },
]);

const toggleAnswer = (id) => {
  faqs.value = faqs.value.map((faq) =>
    faq.id === id ? { ...faq, show: !faq.show } : faq
  );
};

const activeFeature = ref(null);

const toggleFeature = (index) => {
  activeFeature.value = activeFeature.value === index ? null : index;
};

const modalVisible = ref(false)
const activeVideo = ref('')

function openModal(videoUrl) {
  activeVideo.value = videoUrl + '?autoplay=1'
  modalVisible.value = true
}

function closeModal() {
  modalVisible.value = false
  activeVideo.value = ''
}
</script>



<style scoped>
.feature-item {
  animation: fadeInUp 1s ease forwards;
  opacity: 0;
}

.animate__delay-1s {
    animation-delay: 1s;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes floating {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.pulse {
  animation: pulse 2s infinite ease-in-out;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.feature-item:nth-child(1) {
  animation-delay: 0.1s;
}
.feature-item:nth-child(2) {
  animation-delay: 0.2s;
}
.feature-item:nth-child(3) {
  animation-delay: 0.3s;
}
.feature-item:nth-child(4) {
  animation-delay: 0.4s;
}
.feature-item:nth-child(5) {
  animation-delay: 0.5s;
}
.feature-item:nth-child(6) {
  animation-delay: 0.6s;
}
.feature-item:nth-child(7) {
  animation-delay: 0.7s;
}
.feature-item:nth-child(8) {
  animation-delay: 0.8s;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.expand-enter, .expand-leave-to {
  max-height: 0;
  opacity: 0;
}
.expand-enter-active, .expand-leave-active {
  transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out;
}
.expand-enter-to, .expand-leave {
  max-height: 500px;
  opacity: 1;
}


.custom-scrollbar::-webkit-scrollbar {
  height: 2px; 
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 1px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
.custom-scrollbar::before {
  content: '';
  position: absolute;
  left: 0;
  height: 100%;
  width: 40px; 
  background: #FFF9F7; 
}

.custom-scrollbar {
  scrollbar-width: thin; 
  scrollbar-color: #888 #FFF9F7; 
  position: relative;
}



@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.55);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.7s forwards;
}

.animate-fadeInDown {
  animation: fadeInDown 0.7s forwards;
}

.animate-fadeInUp {
  animation: fadeInUp 0.7s forwards;
}

.animate-zoomIn {
  animation: zoomIn 0.7s forwards;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}



@media (prefers-reduced-motion: reduce) {
  .animate-fadeIn,
  .animate-fadeInDown,
  .animate-fadeInUp,
  .animate-zoomIn {
    animation: none;
    opacity: 1 !important; 
    transform: none !important; 
  }
}

@keyframes pulsate {
  0%   { transform: scale(1); }
  50%  { transform: scale(1.10); }
  100% { transform: scale(1); }
}
.pulsate {
  animation: pulsate 5s ease-in-out infinite;
}

@keyframes fluentMarquee {
  0% {
    transform: translateX(70%);
  }
  100% {
    transform: translateX(-70%);
  }
}

.animate-fluentMarquee {
  animation: fluentMarquee 8s linear infinite;
}

/* Pause marquee when the banner is hovered */
.genesis-banner:hover .animate-fluentMarquee {
  animation-play-state: paused;
  opacity: 0.7;
}

</style>
